export const View = [
  {
    image: "./Images/icons/view-icon.svg",
  },
];
